import { Link } from 'react-router'
import type { ReactNode } from 'react'

import { Icon } from './Icon'
import { Text } from './Text'
import './system.css'

export type RowVariant = 'card' | 'plain'

export function Row({
  to,
  title,
  meta,
  icon,
  variant = 'card',
  trailing,
  className,
}: {
  to: string
  title: string
  meta?: ReactNode
  icon?: string | undefined
  variant?: RowVariant
  trailing?: ReactNode
  className?: string
}) {
  const classes = ['row', `row--${variant}`]

  if (className) {
    classes.push(className)
  }

  return (
    <li>
      <Link className={classes.join(' ')} to={to} viewTransition>
        {icon ? (
          <span className="row__icon" aria-hidden="true">
            {icon}
          </span>
        ) : null}
        <span className="row__body">
          <Text as="span" role="body-strong">
            {title}
          </Text>
          {meta ? (
            <Text as="span" role="label" tone="tone">
              {meta}
            </Text>
          ) : null}
        </span>
        {trailing ?? <Icon size="sm">›</Icon>}
      </Link>
    </li>
  )
}
